/**
 * Page backdrop effect used while a modal is open.
 *
 * Scales down and blurs the page wrapper (`.base-container`), and fades in the
 * static `[data-page-backdrop]` overlay (rendered in `base.twig`, sibling of
 * `.base-container` so it isn't affected by the transform/filter). The modal
 * must live outside `.base-container` (e.g. moved to `<body>` via the Modal
 * `move` option) and sit above the overlay's z-index.
 */

const PAGE_SELECTOR = '.base-container';
const OVERLAY_SELECTOR = '[data-page-backdrop]';

/**
 * Toggle the page backdrop effect.
 * @param {boolean} active Whether the scale + blur + dark overlay are on.
 * @returns {void}
 */
export function togglePageBackdrop(active) {
  const page = document.querySelector(PAGE_SELECTOR);
  if (page instanceof HTMLElement) {
    page.style.transition = 'transform .7s ease-in-out, filter 1s ease-in-out';
    page.style.transform = active ? 'scale(0.85)' : '';
    page.style.filter = active ? 'blur(8px)' : '';
  }

  const overlay = document.querySelector(OVERLAY_SELECTOR);
  if (overlay instanceof HTMLElement) {
    overlay.style.opacity = active ? '1' : '0';
  }
}
